import { render, staticRenderFns } from "./PrivateNftMint.vue?vue&type=template&id=51d1aaab&scoped=true&"
import script from "./PrivateNftMint.vue?vue&type=script&lang=js&"
export * from "./PrivateNftMint.vue?vue&type=script&lang=js&"
import style0 from "./PrivateNftMint.vue?vue&type=style&index=0&id=51d1aaab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d1aaab",
  null
  
)

export default component.exports